import React, { useEffect, useState } from 'react'
import './PaystackStatement.scss'
import bankUserProfile from '../../../../Assets/Icons/bank-user-profile.png'
import bank from '../../../../Assets/Icons/bank.png'
import amount from '../../../../Assets/Icons/amount.png'
import authService from 'Services/authService'
import { CurrencyFormatter } from 'Helpers'
import { ModalWrapper } from 'Components'
import TransferFunds from './TransferFunds'

interface paystackstatement {
  minimumAllowedAmount: number
  maximumAllowedAmount: number
  settlementBank: {
    bank: string
    account_number: string
    account_name: string
    currency: string
    bank_code: string
  }
  idempotencyKey: string
}

const PaystackStatement = () => {
  const [paystackstatement, setPaystackstatement] = useState<paystackstatement>()
  const [showModal, setShowModal] = useState<boolean>(false)
  const [title, setTitle] = useState<string>('Transfer')
  const [isCompleted, setIsCompleted] = useState(false)

  const toggleModal = async () => {
    setShowModal(!showModal)
  }

  const getProfile = async () => {
    await authService.getPaystackProfile().then(
      (response) => {
        console.log({ response: response.data.data })
        setPaystackstatement(response.data.data)
      },
      (error) => {
        console.log({ error })
      },
    )
  }

  useEffect(() => {
    getProfile()
  }, [])

  return (
    <div className='PaystackStatement'>
      <div className='container'>
        <div className='row justify-content-center mt-5'>
          <div className='col-md-6'>
            <div className='card border-0'>
              <div className='card-body py-4'>
                <div className='row mb-3'>
                  <div className='col-2 col-xl-1 text-center my-auto'>
                    <div className='icon'>
                      <img src={bank} alt='Bank User Profile' />
                    </div>
                  </div>
                  <div className='col-10 col-xl-11 my-auto'>
                    <div className='label'>
                      <div className='sub-title'>Bank Account Name</div>
                      <div className='title'>{paystackstatement?.settlementBank.account_name}</div>
                    </div>
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-2 col-xl-1 text-center my-auto'>
                    <div className='icon'>
                      <img src={bankUserProfile} alt='Bank User Profile' />
                    </div>
                  </div>
                  <div className='col-10 col-xl-11 my-auto'>
                    <div className='label'>
                      <div className='sub-title'>Settlement Bank Name</div>
                      <div className='title'>{paystackstatement?.settlementBank.account_name}</div>
                    </div>
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-2 col-xl-1 text-center my-auto'>
                    <div className='icon'>
                      <img src={amount} alt='Bank User Profile' />
                    </div>
                  </div>
                  <div className='col-10 col-xl-11 my-auto'>
                    <div className='label'>
                      <div className='sub-title'>Account Number</div>
                      <div className='title'>
                        {paystackstatement?.settlementBank.account_number}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row mb-3'>
                  <div className='col-6 col-sm-7 col-lg-6 min-lable'>
                    Minimum Transferable Amount
                  </div>
                  <div className='col-6 col-sm-5 col-lg-6  min-value text-sm-end'>
                    N{CurrencyFormatter(paystackstatement?.minimumAllowedAmount ?? 0)}
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-6 col-sm-7 col-lg-6 min-lable'>
                    Maximum Transferable Amount
                  </div>
                  <div className='col-6 col-sm-5 col-lg-6 min-value text-sm-end'>
                    N{CurrencyFormatter(paystackstatement?.maximumAllowedAmount ?? 0)}
                  </div>
                </div>

                <div className='text-center'>
                  <button
                    className='btn btn-transfer btn-default'
                    onClick={() => setShowModal(true)}
                  >
                    Transfer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper
        showModal={showModal}
        closeModal={() => {
          toggleModal()
          setIsCompleted(false)
        }}
        title={title}
        hideHeader={isCompleted}
      >
        <TransferFunds
          setTitle={function (value: string): void {
            setTitle(value)
          }}
          idempotencyKey={paystackstatement?.idempotencyKey}
          toggle={function (completeStatus: boolean): void {
            if (completeStatus === true) {
              setIsCompleted(true)
            } else {
              setIsCompleted(false)
              toggleModal()
            }
          }}
        ></TransferFunds>
      </ModalWrapper>
    </div>
  )
}

export default PaystackStatement
